<template>
	<div>
<!--Page de login - Authentification--------------------------------------------------------------------------------------------------------------------------------------------------------->						

	<Authentification/>		

<!--Page d'accueil--------------------------------------------------------------------------------------------------------------------------------------------------------->						

		<v-flex	xs12 md12 v-if="$store.state.authenticated">
			<v-tabs 
				v-model="$store.state.active" 
				color="cyan" 
				dark 
				slider-color="yellow" 
				center-active
				next-icon="mdi-arrow-right-bold-box-outline"
				prev-icon="mdi-arrow-left-bold-box-outline"
				show-arrows
			>
				<v-tab key="1" ripple @click="rechercheMenu">
					<h3>Recherches</h3>
				</v-tab>
				<v-tab-item key="1">
					<v-container grid-list-md text-center>
						<v-layout wrap v-if="$store.state.VueRechercheMenu">
							<v-flex xs12 sm6>
								<v-card class="cardWrapper" color="grey lighten-5" min-height="210" height="auto">
									<div class="cardContainer">
										<v-card-title>
											<h3 v-on:click="rechercheArticle">Recherche par article</h3>
										</v-card-title>
										<v-card-text>
											<v-flex	xs12 offset-sm1 v-on:click="rechercheArticle">
												Recherche par référence Conectis ou ggm ASW
											</v-flex>
										</v-card-text>
									</div>
									<div>
										<v-card-actions>
											<v-btn text @click="rechercheArticle">Suite</v-btn>
										</v-card-actions>
									</div>
								</v-card>
							</v-flex>
							<v-flex xs12 sm6>
								<v-card class="cardWrapper" color="grey lighten-5" min-height="210" height="auto">
									<div class="cardContainer">
										<v-card-title>
											<h3 v-on:click="rechercheDesignation">Recherche par désignation</h3>
										</v-card-title>
										<v-card-text>
											<v-flex	xs12 offset-sm1 v-on:click="rechercheDesignation">
												Recherche par désignation article
											</v-flex>
										</v-card-text>
									</div>
									<div>
										<v-card-actions>
											<v-btn text @click="rechercheDesignation">Suite</v-btn>
										</v-card-actions>
									</div>
								</v-card>
							</v-flex>
							<v-flex xs12 sm6>
								<v-card class="cardWrapper" color="grey lighten-5" min-height="210" height="auto">
									<div class="cardContainer">
										<v-card-title>
											<h3 v-on:click="rechercheOffre">Recherche par n° d'offre</h3>
										</v-card-title>
										<v-card-text>
											<v-flex	xs12 offset-sm1 v-on:click="rechercheOffre">
												Recherche par n° d'offre Conectis
											</v-flex>
										</v-card-text>
									</div>
									<div>
										<v-card-actions>
											<v-btn text @click="rechercheOffre">Suite</v-btn>
										</v-card-actions>
									</div>
								</v-card>
							</v-flex>
							<v-flex xs12 sm6>
								<v-card class="cardWrapper" color="grey lighten-5" min-height="210" height="auto">
									<div class="cardContainer">
										<v-card-title>
											<h3 v-on:click="rechercheProjet">Recherche par projet</h3>
										</v-card-title>
										<v-card-text>
											<v-flex	xs12 offset-sm1 v-on:click="rechercheProjet">
												Recherche par nom de projet ggm
											</v-flex>
										</v-card-text>
									</div>
									<div>
										<v-card-actions>
											<v-btn text @click="rechercheProjet">Suite</v-btn>
										</v-card-actions>
									</div>
								</v-card>
							</v-flex>
						</v-layout>
						
<!--Recherche par article--------------------------------------------------------------------------------------------------------------------------------------------------------->						

						<RechercheParArticle/>

<!--Recherche par désignation--------------------------------------------------------------------------------------------------------------------------------------------------------->						

						<RechercheParDesignation/>

<!--Recherche par n° d'offre--------------------------------------------------------------------------------------------------------------------------------------------------------->						

						<RechercheParNoOffre/>
						
<!--Recherche par projet--------------------------------------------------------------------------------------------------------------------------------------------------------->						

						<RechercheParProjet/>

<!--Fin page d'accueil--------------------------------------------------------------------------------------------------------------------------------------------------------->						

					</v-container>
				</v-tab-item>

<!--Page Création d'offre ASW--------------------------------------------------------------------------------------------------------------------------------------------------------->						
				<v-tab key="2" ripple>
					<h3>Créer offre ASW</h3>
				</v-tab>
				<v-tab-item key="2">
					<CreationOffreASW/>
				</v-tab-item>

<!--Page Import offres Conectis--------------------------------------------------------------------------------------------------------------------------------------------------------->						

				<v-tab key="3" ripple>
					<h3>Import offres Conectis</h3>
				</v-tab>
				<v-tab-item key="3">
					<ImportOffresConectis/>
				</v-tab-item>
		
<!--Import liste de prix--------------------------------------------------------------------------------------------------------------------------------------------------------->						

				<v-tab key="4" ripple v-if="$store.state.authenticatedAdmin">
					<h3>Import liste de prix</h3>
				</v-tab>
				<v-tab-item key="4">
					<ImportListePrix/>
				</v-tab-item>

<!--Page gestion des utilisateurs--------------------------------------------------------------------------------------------------------------------------------------------------------->						

				<v-tab key="5" ripple  v-if="$store.state.authenticatedAdmin" @click="getUsersList">
					<h3>Utilisateurs</h3>
				</v-tab>
				<v-tab-item key="5">
					<GestionUtilisateurs/>
				</v-tab-item>

			</v-tabs>
		</v-flex>
	</div>

</template>

<!--Scripts--------------------------------------------------------------------------------------------------------------------------------------------------------->						

<script>
	import axios from 'axios';
	import Authentification from './Authentification.vue';
	import RechercheParArticle from './RechercheParArticle.vue';
	import RechercheParDesignation from './RechercheParDesignation.vue';
	import RechercheParNoOffre from './RechercheParNoOffre.vue';
	import RechercheParProjet from './RechercheParProjet.vue';
	import CreationOffreASW from './CreationOffreASW.vue';
	import ImportOffresConectis from './ImportOffresConectis.vue';
	import GestionUtilisateurs from './GestionUtilisateurs.vue';
	import ImportListePrix from './ImportListePrix.vue';

	export default {
		name: "Formulaire",
		components: {
			Authentification,
			RechercheParArticle,
			RechercheParDesignation,
			RechercheParNoOffre,
			RechercheParProjet,
			CreationOffreASW,
			ImportOffresConectis,
			GestionUtilisateurs,
			ImportListePrix
		},
		data: function () {
			return {
				axios_error: "",
                attachment_oversize_text: "",
				priceListFile: {},
				quotationReference: null,
				quotationNumber: null,
				quotationDate: null,
				quotationValidityDate: null,
				quotationDateReminder: null,
				quotationValidityDateReminder: null,
				quotationTitleSave: null,
				tempProjectTitle: null,
				plFile: {},
				plOk: false,
				plTooBig: false,
				plExtension: "",
				plExtensionOk: true,
				plExists: false,
				uploadPlComment: null,
				fileSize: 0,
				projet: "",
				attachment_size: 0,
				attachment_oversize: false,
				postBody: "",
				errors: [],
				model: 1,
				designations: null,
				marque: "",
				dataXlsx: null,
				singleSelect: false,
				searchProjects: null,
				selected: [],
				filters: [
					{
						value: 1,
						fn: (item, queryText) => queryText.length > 0 && item.toLowerCase().indexOf(queryText) > -1,
						text: "Search Length > 2 & Loose Match",
					},
				],
			};
		},
		created() {
			axios.interceptors.request.use((config) => {
				this.setLoading(true);
				return config;
			}, (error) => {
				this.setLoading(false);
				return Promise.reject(error);
			});
			axios.interceptors.response.use((response) => {
				this.setLoading(false);
				return response;
			}, (error) => {
				this.setLoading(false);
				return Promise.reject(error);
			});
		},
		mounted() {
			var link = "http://domoserver.ddns.net/gigamedia1/loadArticles.php";
			axios.get(link).then(response => (this.$store.state.articles = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadDesignations.php";
			axios.get(link).then(response => (this.designations = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadMarques.php";
			axios.get(link).then(response => (this.$store.state.marques = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadQuotations.php";
			axios.get(link).then(response => (this.$store.state.quotations = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadQuotation.php?quotationReference=";
			axios.get(link).then(response => (this.$store.state.ConectisQuotation = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadArticleData.php?edi_code=";
			axios.get(link).then(response => (this.$store.state.dataArticle = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadDesignationData.php?libelle=";
			axios.get(link).then(response => (this.$store.state.dataDesignation = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadArticleQuotations.php?edi_code=";
			axios.get(link).then(response => (this.$store.state.ArticleQuotations = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadProjects.php";
			axios.get(link).then(response => (this.$store.state.projects = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadProject.php?projectReference=";
			axios.get(link).then(response => (this.$store.state.ggmProject = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadQuotationsFiles.php?quotationTitle=";
			axios.get(link).then(response => (this.$store.state.ggmProjectQuotationTitle = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/quotationConvert.php?quotationNumber=&netstoreSession=";
			axios.get(link).then(response => (this.$store.state.netstoreReport = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadInfoDesignation.php";
			axios.get(link).then(response => (this.$store.state.infoDesignation = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadStockConectis.php";
			axios.get(link).then(response => (this.$store.state.stockConectis = response.data));
			link = "http://domoserver.ddns.net/gigamedia1/loadUsersList.php";
			axios.get(link).then(response => (this.$store.state.usersList = response.data));
		},
		methods: {
			getUsersList: function () {
				var link = "http://domoserver.ddns.net/gigamedia1/loadUsersList.php";
				axios.get(link).then(response => (this.$store.state.usersList = response.data));
			},
			setLoading(temp_state) {
				if (temp_state) {
					this.$store.state.is_loading = true;
				}
				else {
					this.$store.state.is_loading = false;
				}
			},
            rechercheMenu: function () {
                this.$store.state.VueRechercheMenu = true;
                this.$store.state.VueRechercheArticle = false;
                this.$store.state.VueRechercheDesignation = false;
                this.$store.state.VueRechercheOffre = false;
                this.$store.state.VueRechercheProjet = false;
            },
			rechercheArticle: function () {
				this.$store.state.edi = "";
				this.$store.state.ArticleQuotations = [];
				this.$store.state.VueRechercheMenu = false;
				this.$store.state.VueRechercheArticle = true;
				this.$store.state.articleSelectedQuotationNumber = "";
				this.$store.state.articleSelectedQuotationFileName = "";
			},
			rechercheOffre: function () {
				this.$store.state.quotationReference = null;
				this.$store.state.ArticleQuotations = [];
				this.$store.state.VueRechercheMenu = false;
				this.$store.state.VueRechercheOffre = true;
			},
			rechercheDesignation: function () {
				this.$store.state.selected = [];
				this.$store.state.designationSelectedArticle = null;
				this.$store.state.libelle = "";
				this.marque = "";
				this.$store.state.ArticleQuotations = [];
				this.$store.state.VueRechercheMenu = false;
				this.$store.state.VueRechercheDesignation = true;
				this.$store.state.articleSelectedQuotationNumber = "";
				this.$store.state.articleSelectedQuotationFileName = "";
			},
			rechercheProjet: function () {
				this.projectReference = null;
				this.$store.state.ArticleQuotations = [];
				this.$store.state.VueRechercheMenu = false;
				this.$store.state.VueRechercheProjet = true;
				var link = "http://domoserver.ddns.net/gigamedia1/loadProjects.php";
				axios.get(link).then(response => (this.$store.state.projects = response.data));
			},
		},
	}

</script>

<style>
	h2 {
		margin: 10px;
	}
	.progress {
		margin-top: 1px;
	}
	.cardWrapper {
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
	}
	.table-bordered {
		border-collapse: collapse;
	}
	.table-bordered {
		border: 1px solid black;
	}
	.th-bordered {
		border: 1px solid black;
	}
	.td-bordered {
		border: 1px solid black;
	}
	tr:hover {background-color: #f5f5f5;}
</style>
